var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup627089(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 627089"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 36,
    cy: 36.5,
    r: 34,
    fill: "#19962A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_222_11075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 2.5C17.3 2.5 2 17.8 2 36.5C2 55.2 17.3 70.5 36 70.5C54.7 70.5 70 55.2 70 36.5C70 17.8 54.7 2.5 36 2.5ZM30.6142 52.0858C29.8332 52.8668 28.5668 52.8668 27.7858 52.0858L14.5987 38.8987C13.2739 37.5739 13.2739 35.4261 14.5987 34.1013C15.9221 32.7779 18.0674 32.7764 19.3927 34.098L27.8438 42.5256C28.5931 43.2728 29.8061 43.2719 30.5543 42.5237L52.592 20.486C53.9238 19.1542 56.0843 19.158 57.4115 20.4945C58.732 21.8244 58.7282 23.9718 57.403 25.297L30.6142 52.0858Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 36.5C2.5 18.0761 17.5761 3 36 3C54.4239 3 69.5 18.0761 69.5 36.5C69.5 54.9239 54.4239 70 36 70C17.5761 70 2.5 54.9239 2.5 36.5ZM27.4322 52.4393C28.4085 53.4157 29.9915 53.4156 30.9678 52.4393L57.7565 25.6506C59.2765 24.1306 59.2809 21.6676 57.7663 20.1422C56.2441 18.6092 53.766 18.6049 52.2384 20.1325L30.2008 42.1701C29.6476 42.7233 28.7508 42.724 28.1968 42.1715L19.7457 33.7439C18.2251 32.2275 15.7636 32.2293 14.2451 33.7478C12.7251 35.2678 12.7251 37.7322 14.2451 39.2522L27.4322 52.4393Z",
    stroke: "url(#paint0_linear_222_11075)",
    strokeOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_222_11075",
    x: 0,
    y: 0.5,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_222_11075"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_11075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_11075",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_11075",
    x1: 36,
    y1: 2.5,
    x2: 36,
    y2: 70.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup627089);
export default __webpack_public_path__ + "static/media/Group 627089.8a2428cb3869ff3728e91317f98c83d3.svg";
export { ForwardRef as ReactComponent };